import type { ReactNode } from 'react';
import isObject from 'lodash/isObject';
import type { PosPageHeaderProps } from 'pos-client/layouts/page/PosPageHeader';

export const isPosPageHeader = (
  val: PosPageHeaderProps | ReactNode
): val is PosPageHeaderProps =>
  isObject(val) ? !Object.hasOwn(val, '$$typeof') : false;
